<template>
  <div
    class="rounded-b relative"
    :class="[teacher_tap_in ? 'h-72 border border-solid border-gray-200 w-96 flex items-center justify-center -mt-16' : 'bg-gray-100 h-56']"
  >
    <div class="absolute left-0 bottom-0 top-0 right-0 z-20 w-full h-full">
      <div class="relative w-full h-full">
        <div class="flex flex-col space-y-2 h-full">
          <div :class="{'bg-gray-300 bg-opacity-50 backdrop-blur-lg': cameraOn, 'bg-gray-800 bg-opacity-50  backdrop-blur-lg': !cameraOn || teacher_tap_in }" class="font-poppins text-xs w-full py-0.5 text-white text-center">
            Teacher
          </div>
          <div class="flex justify-between items-center px-2">
            <div v-if="teacher_tap_in" class="rounded-tr-full bg-blue-700 text-base rounded-br-full rounded-tl-full cursor-pointer flex items-center space-x-2 px-3 py-1">
              <div><i class="fa-solid fa-chalkboard-user text-white"></i></div>
              <span class="text-white text-xs font-poppins font-medium">Teacher Tap In</span>
            </div>
            <div v-else></div>
            <div v-if="teacher_speaking[author_id]">
              <VolumeIndicator />
            </div>
          </div>
          <div @mouseover="isToSeeSettings = true" @mouseleave="isToSeeSettings = false" class="flex px-2 flex-grow h-full w-full">
            <div class="flex justify-center items-center w-full">
              <button
                v-if="video_audio_is_active && joinedAudioDiscussion && is_my_teacher && cameraOn && isToSeeSettings"
                @click="openDeviceSettings()"
                class="flex justify-center text-center items-center bg-gray-500 bg-opacity-50 h-10 w-10 rounded-full"
              >
                <i class="fa-solid fa-gear text-white text-center text-lg" />
              </button>
            </div>
          </div>
          <div class="flex items-center justify-between pb-2 px-2">
            <div class="flex space-x-1.5 bg-gray-800 bg-opacity-50 rounded-full px-3 py-1.5 h-7 items-center">
              <div class="truncate text-white max-width-name text-xs">
                <span>{{ author_name }}</span>
                <span v-if="is_my_teacher" class="text-pinky ml-0.5">(Me)</span>
              </div>
            </div>
            <!-- <div v-if="video_audio_is_active && joinedAudioDiscussion && is_my_teacher" class="flex items-center space-x-1 text-xs">
              <button @click="toggleCam()" class="bg-gray-800 bg-opacity-50 px-3 h-7 py-1.5 w-10 rounded-full text-white hover:bg-white shadow hover:text-gray-800">
                <i :class="cameraOn === true ? 'fa-video' : 'fa-video-slash'" class="fa-solid" />
              </button>
              <button @click="toggleMic()" class="bg-gray-800 bg-opacity-50 px-3 h-7 w-10 py-1.5 rounded-full text-white hover:bg-white shadow hover:text-gray-800">
                <i :class="micOn === true ? 'fa-microphone' : 'fa-microphone-slash'" class="fa-solid" />
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="absolute" style="top: calc(50% - 40px); left: calc(50% - 40px)">
      <img
        :src="avatar_url"
        class="rounded-full object-cover"
        :style="{
          width: teacher_tap_in ? '90px' : '70px',
          height: teacher_tap_in ? '90px' : '70px',
        }"
      />
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import VolumeIndicator from './volumeIndicator.vue';

  export default {
    data() {
      return {
        video_audio_is_active: false,
        teacher_speaking: {},
        micOn: false,
        cameraOn: true,
        isToSeeSettings: false,
      };
    },
    components: {
      VolumeIndicator,
    },
    props: {
      joinedAudioDiscussion: {
        type: Boolean,
        default: false,
      },
      remoteUsers: {
        type: Array,
        default() {
          return [];
        },
      },
      rtc: {
        type: Object,
        default: {
          client: null,
          localAudioTrack: null,
          localVideoTrack: null,
        },
      },
      teacher_tap_in: {
        type: String,
        default: '',
      },
      course_author: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    watch: {
      'getCurrentDiscussion.audio_discussion_is_enabled'() {
        this.video_audio_is_active =
          this.getCurrentDiscussion.audio_discussion_is_enabled;
      },
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
        'getCourseDetail',
        'getProfile',
        'hasTeacherPermissionsInCourse',
        'getQueue',
      ]),
      author_id() {
        return Object.keys(this.course_author).length
          ? this.course_author.id
          : this.getCurrentDiscussion.author.id;
      },
      author_name() {
        return Object.keys(this.course_author).length
          ? this.course_author.name
          : this.getCurrentDiscussion.author.name;
      },
      avatar_url() {
        return Object.keys(this.course_author).length
          ? this.course_author.avatar_url
          : this.getCurrentDiscussion.author.avatar_url;
      },
      teacher_joined_LD() {
        if (this.remoteUsers) {
          const teacher = this.remoteUsers.find(
            (ru) => ru.uid === this.author_id
          );
          return !!teacher;
        }
        return false;
      },
      is_my_teacher() {
        return this.author_id === this.getProfile.id;
      },
    },
    methods: {
      toggleMic() {
        this.micOn = !this.micOn;
        if (this.micOn) {
          EventBus.$emit('unmuteAudio');
        } else {
          EventBus.$emit('muteAudio');
        }
      },
      toggleCam() {
        this.cameraOn = !this.cameraOn;
        if (this.cameraOn) {
          EventBus.$emit('videoOn');
        } else {
          EventBus.$emit('videoOff');
        }
      },
      openDeviceSettings() {
        EventBus.$emit('end-live-audio');
        this.cameraOn = true;
        this.micOn = false;
      },
    },
    mounted() {
      this.video_audio_is_active =
        this.getCurrentDiscussion.audio_discussion_is_enabled;

      EventBus.$on('end-participation-audio-live', () => {
        this.video_audio_is_active = false;
      });
      EventBus.$on('teacher_speaking', (teachers_list) => {
        this.teacher_speaking = teachers_list;
      });
      EventBus.$on('isCameraOn', (status) => {
        this.cameraOn = status;
      });
    },
    beforeDestroy() {
      EventBus.$off('end-participation-audio-live');
      EventBus.$off('teacher_speaking');
      EventBus.$off('isCameraOn');
    },
  };
</script>
<style lang="stylus" scoped>
  .participation-footer
    font-size: 10px
    color: white
</style>



// WEBPACK FOOTER //
// LDDiscussionTeacherCircle.vue?4b339558